export default "__VITE_ASSET__d461adb4__"